import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// This component protects routes that need authentication
function PrivateRoute({ children }) {
    const { isLoggedIn, loading } = useAuth();

    // Show loading while checking auth
    if (loading) {
        return <div>Loading...</div>;
    }

    // If user is logged in, show the protected content
    if (isLoggedIn) {
        return children;
    }

    // If not logged in, redirect to login page
    return <Navigate to="/login" replace />;
}

export default PrivateRoute;